<div class="alpha">
    <input name="alpha-slider" type="range" min="0" max="100" step="1" [formControl]="alpha" />
    <div [style.left]="position$ | async" [style.color]="markerColor$ | async" id="alpha-marker"></div>
    <span #slider [style.color]="sliderColor$ | async"></span>
</div>
